import { apiGet, apiPost } from "./client";
import type {
  SupportQueue,
  SupportReplyRequest,
  SupportReplyResponse,
  SupportStats,
  SupportTicketDetail,
} from "@/types/support";

/** Sem filtro por query: o escopo (quais eventos) vem da sessão do usuário logado. */
export function getSupportQueue(): Promise<SupportQueue> {
  return apiGet<SupportQueue>("/api/atendimento/fila");
}

/** Sem filtro por query: o escopo (quais eventos) vem da sessão do usuário logado. */
export function getSupportStats(): Promise<SupportStats> {
  return apiGet<SupportStats>("/api/atendimento/stats");
}

export function getSupportTicket(ticketId: number | string): Promise<SupportTicketDetail> {
  return apiGet<SupportTicketDetail>(`/api/atendimento/ticket/${ticketId}`);
}

export function replySupportTicket(
  ticketId: number | string,
  body: SupportReplyRequest,
): Promise<SupportReplyResponse> {
  return apiPost<SupportReplyResponse>(`/api/atendimento/ticket/${ticketId}/responder`, body);
}
